import {BrowserRouter, Route, Switch, Redirect} from 'react-router-dom'
import React, {Component} from 'react'
import Cookies from 'js-cookie'
import Header from './components/Header/Header'
import HomeRoute from './components/Home/HomeRoute'
import LoginRoute from './components/Login/LoginRoute'
import JobsRoute from './components/Jobs/JobsRoute'
import JobItemDetailsRoute from './components/JobItemDetails/JobItemDetailsRoute'
import NotFoundRoute from './components/NotFound/NotFoundRoute'
import ProtectedRoute from './components/ProtectedRoute' // New Component

import './App.css'

// These are the lists used in the application. You can move them to any component needed.
const employmentTypesList = [
  {
    label: 'Full Time',
    employmentTypeId: 'FULLTIME',
  },
  {
    label: 'Part Time',
    employmentTypeId: 'PARTTIME',
  },
  {
    label: 'Freelance',
    employmentTypeId: 'FREELANCE',
  },
  {
    label: 'Internship',
    employmentTypeId: 'INTERNSHIP',
  },
]

const salaryRangesList = [
  {
    salaryRangeId: '1000000',
    label: '10 LPA and above',
  },
  {
    salaryRangeId: '2000000',
    label: '20 LPA and above',
  },
  {
    salaryRangeId: '3000000',
    label: '30 LPA and above',
  },
  {
    salaryRangeId: '4000000',
    label: '40 LPA and above',
  },
]

class App extends Component {
  handleLogin = token => {
    Cookies.set('jwt_token', token, {expires: 1}) // Store JWT token
  }

  handleLogout = () => {
    Cookies.remove('jwt_token')
  }

  render() {
    return (
      <Switch>
        {/* Login Route */}
        <Route exact path="/login" component={LoginRoute} />

        {/* Protected Routes with Header */}
        <ProtectedRoute exact path="/" component={HomeRoute} />
        <ProtectedRoute exact path="/jobs" component={JobsRoute} />
        <ProtectedRoute
          exact
          path="/jobs/:id"
          component={JobItemDetailsRoute}
        />

        {/* Not Found Route */}
        <Route exact path="/not-found" component={NotFoundRoute} />
        <Redirect to="/not-found" />
      </Switch>
    )
  }
}

export default App
